// extracted by mini-css-extract-plugin
export default {"textStyle":"textStyle-qRABS","sortingContainer":"sortingContainer-_hbJm","dropdownTitle":"dropdownTitle-Yyoxj","menu":"menu-gpou8"};